import React from "react";
import {Pagination} from "react-bootstrap";

function STCPaginationEllipsis(props){

    return(
        <Pagination.Ellipsis>
            {props.children}
        </Pagination.Ellipsis>
    )
}
export default STCPaginationEllipsis;